import { getDefaultNormalizer } from "@testing-library/dom";

export const hospitalLIst = {
	Alberta: [
		{
			key: 1,
			name: 'Banff Mineral Springs Hospital',
			description:
				"Alberta Children's Hospital (ACH) is the largest public hospital for sick children in the prairie provinces, and is located in Calgary, Alberta, Canada",
			location: '28 Oki Dr NW, Calgary, AB T3B 6A8',
			phoneNumber: '(403) 955-7211',
		},
		{
			key: 2,
			name: 'Canmore General Hospital',
			description:
				'Canmore General Hospital is a medical facility located in Canmore, Alberta, Canada. Alberta Health Services is responsible for the operations of the hospital. It is a referral centre for surgical services within the province of Alberta',
			location: '1100 Hospital Pl, Canmore, AB T1W 1N2',
			phoneNumber: '(403) 678-5536',
		},
		{
			key: 3,
			name: 'Cross Cancer Institute',
			description:
				'Cross Cancer Institute is the comprehensive cancer centre for northern Alberta.The institute is located in Edmonton near the southwest corner of the University of Alberta, and is one of two tertiary cancer centres in the province. ',
			location: '11560 University Ave, Edmonton, AB T6G 1Z2',
			phoneNumber: '(780) 432-8771',
		},
		{
			key: 4,
			name: 'Glenrose Rehabilitation Hospital',
			description: 'The Glenrose Rehabilitation Hospital is located in Edmonton, Alberta, Canada. ',
			location: '10230 111 Ave NW, Edmonton, AB T5G 0B7',
			phoneNumber: '(780) 735-7999',
		},
		{
			key: 5,
			name: 'Royal Alexandra Hospital',
			description:
				"The Royal Alexandra Hospital is a large and long serving hospital in the Canadian province of Alberta. Operated by Alberta Health Services and located north of Edmonton's downtown core",
			location: '10240 Kingsway NW, Edmonton, AB T5H 3V9',
			phoneNumber: '(780) 735-4111',
		},
	],
	BritishColumbia: [
		{
			key: 1,
			name: 'Burnaby Hospital',
			description:
				'Burnaby Hospital, is a healthcare facility located in Burnaby, British Columbia and operated by the Fraser Health Authority.',
			location: '3935 Kincaid St, Burnaby, BC V5G 2X6',
			phoneNumber: '(604) 434-4211',
		},
		{
			key: 2,
			name: 'South Okanagan General Hospital',
			description:
				'South Okanagan General Hospital is a hospital operating under the governance of Interior Health. It is located in the town of Oliver, British Columbia',
			location: '911 McKinney Rd, Oliver, BC V0H 1T0',
			phoneNumber: '(250) 498-5000',
		},
		{
			key: 3,
			name: 'Surrey Memorial Hospital',
			description:
				'Surrey Memorial Hospital is a publicly funded hospital owned and operated by Fraser Health in the city of Surrey, British Columbia,',
			location: '13750 96 Ave, Surrey, BC V3V 1Z2',
			phoneNumber: '(604) 581-2211',
		},
		{
			key: 4,
			name: 'BC Women’s Hospital',
			description:
				"B.C. Women's Hospital & Health Centre, an agency of the Provincial Health Services Authority, is a Canadian hospital located in Vancouver, British Columbia,",
			location: '4500 Oak St, Vancouver, BC V6H 3N1',
			phoneNumber: '(604) 875-2424',
		},
		{
			key: 5,
			name: "St. Paul's Hospital",
			description:
				"St. Paul's Hospital is an acute care hospital located in downtown Vancouver, British Columbia, Canada. It is the oldest of the seven health care facilities operated by Providence Health Care",
			location: '1081 Burrard St, Vancouver, BC V6Z 1Y6',
			phoneNumber: ' (604) 806-9090',
		},
	],
	Manitoba: [
		{
			key: 1,
			name: 'Concordia Hospital',
			description:
				'Concordia Hospital is a regional hospital in Winnipeg, Manitoba that was founded in 1928, and has a primary service area with a population exceeding 150,000. ',
			location: '1095 Concordia Ave, Winnipeg, MB R2K 3S8',
			phoneNumber: ' (204) 667-1560',
		},
		{
			key: 2,
			name: 'Grace Hospital',
			description:
				'Grace Hospital is a regional hospital in Winnipeg, Manitoba, Canada. The 250-bed hospital is located in the Crestview neighbourhood of St. James-Assiniboia. ',
			location: '300 Booth Dr, Winnipeg, MB R3J 3M7',
			phoneNumber: '(204) 837-0111',
		},
		{
			key: 3,
			name: 'Riverview Health Centre',
			description:
				'Riverview Health Centre is a community hospital in Winnipeg, Manitoba, Canada. It was founded in 1911 by the City of Winnipeg as the Winnipeg Municipal Hospital',
			location: 'Morley Avenue, Winnipeg, MB R3L 2P4',
			phoneNumber: '(204) 452-3411',
		},
		{
			key: 4,
			name: 'Seven Oaks General Hospital',
			description:
				'Seven Oaks General Hospital is a community hospital in Winnipeg, Manitoba, Canada. It was founded in 1981 by community leaders and approved by the province of Manitoba to serve the needs of the northern part of Winnipeg',
			location: '2300 McPhillips St, Winnipeg, MB R2V 3M3',
			phoneNumber: '(204) 632-7133',
		},
		{
			key: 5,
			name: 'Health Sciences Centre',
			description:
				'The Health Sciences Centre is the largest hospital in Winnipeg, Manitoba, and one of the largest in Canada',
			location: ' 820 Sherbrook St, Winnipeg, MB R3A 1R9',
			phoneNumber: '(204) 787-3661',
		},
	],
	Ontario: [
		{
			key: 1,
			name: 'Royal Victoria Regional Health Centre- Emergency Department',
			description:
				'The Royal Victoria Regional Health Centre is an Advanced Level II facility with stroke designation, serving the needs of the population of the City of Barrie and the surrounding area.',
			location: '201 Georgian Dr, Barrie, ON L4M 6M2',
			phoneNumber: ' (705) 728-9090',
		},
		{
			key: 2,
			name: 'Campbellford Memorial Hospital',
			description:
				'The Campbellford Memorial Hospital is an Ontario class C and class G 34-bed hospital in the community of Campbellford, municipality of Trent Hills',
			location: '146 Oliver Rd, Campbellford, ON K0L 1L0',
			phoneNumber: '(705) 653-1140',
		},
		{
			key: 3,
			name: 'Georgetown Hospital',
			description:
				'The Georgetown Hospital is a community hospital located in the Georgetown area of Halton Hills, Ontario. It is part of the Halton Healthcare Services group of hospitals.',
			location: '1 Princess Anne Dr, Georgetown, ON L7G 2B8',
			phoneNumber: ' (905) 873-0111',
		},
		{
			key: 4,
			name: "St. Peter's Hospital",
			description:
				"St. Peter's Hospital is a 250-bed chronic care hospital located in East Hamilton, Ontario specializing in the care of older adults.",
			location: '88 Maplewood Ave, Hamilton, ON L8M 1W9',
			phoneNumber: ' (905) 777-3837',
		},
		{
			key: 5,
			name: 'London Health Sciences Centre',
			description:
				"London Health Sciences Centre is a hospital network in London, Ontario and is collectively one of Canada's largest acute-care teaching hospitals. ",
			location: '800 Commissioners Rd E, London, ON N6A 5W9',
			phoneNumber: '(519) 685-8500',
		},
	],
	Quebec: [
		{
			key: 1,
			name: 'Lachine Hospital (Hôpital de Lachine)',
			description:
				'Lachine Hospital is a public hospital in Montreal, Quebec, Canada. It is located at 650 16th Avenue in the borough of Lachine. It is the only French-language hospital on the western portion of the Island of Montreal.',
			location: '650 16 Ave, Lachine, Quebec H8S 3N5',
			phoneNumber: '(514) 934-1934',
		},
		{
			key: 2,
			name: 'Maisonneuve-Rosemont Hospital',
			description:
				'Hôpital Maisonneuve-Rosemont is a hospital in Montreal, Quebec, Canada, located in the borough of Rosemont–La Petite-Patrie. It serves the eastern part of the city and offers 800 beds.',
			location: ' 5415 Assumption Blvd, Montreal, Quebec H1T 2M4',
			phoneNumber: '(514) 252-3400',
		},
		{
			key: 3,
			name: "Montreal Children's Hospital",
			description:
				"Montreal Children's Hospital is a children's hospital in Montreal, Quebec, Canada. Founded in 1904, it is affiliated with the McGill University Health Centre",
			location: '1001 Decarie Blvd, Montreal, Quebec H4A 3J1',
			phoneNumber: '(514) 412-4400',
		},
		{
			key: 4,
			name: 'Montreal Heart Institute',
			description:
				'The Montreal Heart Institute, in Montreal, Quebec, is a specialty hospital dedicated to the development of cardiology, which is affiliated with the Université de Montréal.',
			location: '5000 Rue Bélanger, Montréal, QC H1T 1C8',
			phoneNumber: '(514) 376-3330',
		},
		{
			key: 5,
			name: 'Jewish General Hospital',
			description:
				'The Jewish General Hospital, known officially as the Sir Mortimer B. Davis Jewish General Hospital since 1978, is an acute-care teaching hospital in Montreal, Quebec, Canada.',
			location: '3755 Chemin de la Côte-Sainte-Catherine, Montréal, QC H3T 1E2',
			phoneNumber: ' (514) 340-8222',
		},
	],
};


export const ProvinceList = [{
	key: 1,
	image: 'BC.png',
	name: 'British Coloumbia',
	link: "http://www2.gov.bc.ca/gov/content/health/health-drug-coverage/msp/bc-residents/benefits/services-covered-by-msp",
	features: "	Physician services ,Medically necessary eye exams,Diagnostic services ,Supplemental insurance is strongly recommended ,Some orthodontic services"
},
{
	key: 2,
	image: 'Alberta.png',
	name: 'Alberta',
	link: "https://www.alberta.ca/ahcip-what-is-covered.aspx",
	features:
		" Physician services, hospital services, surgery , Standard ward hospitalization and drugs administered in a hospital,Psychiatric visits, Oral surgery in hospital, Podiatry is eligible to an extent"
}, {
	key: 3,
	image: 'Manitoba.jpg',
	link: "https://www.gov.mb.ca/health/mhsip/index.html",
	name: 'Manitoba',
	features: "Physician services, surgery / anaesthesia, x-ray and laboratory services are covered, Dental surgery is reimbursed when hospitalization is required,Ambulance fees are covered Chiropractic care is eligible up to seven visits per calendar year,Supplemental insurance is strongly recommended "
},
{
	key: 4,
	image: 'ontario.jpeg',
	name: 'Ontario',
	link: "https://www.ontario.ca/page/what-ohip-covers",
	features: 'Doctor visits, including those at walk-in clinics, Dental surgery when performed in hospital,Prescription drugs: coverage is available for people up to age 25. There is a senior drug  for seniors over age 6,Ambulance services are covered to an extent,Supplemental insurance is strongly recommended'
},
{
	key: 5,
	image: 'Quebec.png',
	name: 'Quebec',
	link: "http://www.ramq.gouv.qc.ca/en/citizens/health-insurance/covered-services/Pages/covered-services-accessory-costs.aspx",
	features: 'General practitioner and specialist physician services only by those who have not withdrawn from RAMQ,Cortisone, eye drop,Medical procedures (e.g. surgery) and anesthetics ,Urine and glycemia test,Supplemental Insurance is strongly recommended'
}];


export const doctorsList = [
	{
		name: "ashwin rishi",
		qualification: "MBBS,MD(Gastro)",
		experience: 25,
		hospitalName: "Apollo Greams Road",
		description: "specialist in treating ibs and ibd and Respond to patients’ medical problems by referring to their history, carrying out diagnosis, treatment, counseling, and referral, where necessary and Order lab tests and interprets the test results,Maintain confidentiality and impartiality at all times.",
		slots: [10, 12, 14, 18, 20, 22],
		email: "ashwinrishi",
		consultationFees: 800,
		patientsCount: 1000
	},
	{
		name: "naveen prasad",
		qualification: "MBBS,MD(Gastro)",
		experience: 28,
		hospitalName: "Apollo Greams Road",
		description: "specialist in treating liver and kidney functions & Meet targets set by the government for specified treatments eg. child immunization.Discuss and evaluate new pharmaceutical products with pharmaceutical representatives.",
		slots: [10, 12, 14, 18, 20, 22],
		email: "naveenprasad",
		consultationFees: 1000,
		patientsCount: 10000
	},
	{
		name: "devi prasad",
		qualification: "MBBS,MD(Gastro),DM",
		experience: 30,
		hospitalName: "Apollo Greams Road",
		description: "specialist in surgery & Collect, record, and maintain sensitive patient information such as examination results, medical history, and reports.Perform minor surgeries.Explain procedures or prescribed treatments to patients,Liaise with medical professionals in the community and hospitals.",
		slots: [10, 12, 14, 18, 20, 22],
		email: "deviprasad",
		consultationFees: 1200,
		patientsCount: 1000
	},
	{
		name: "yamini",
		qualification: "MBBS",
		experience: 22,
		hospitalName: "Apollo Greams Road",
		description: "specialist in treating ibs and ibd Degree in Medicine (essential) . 5 years of residency training (essential).current state medical license and Federal DEA license (essential).Completed U.S. Medical Licensing Examination (essential).",
		slots: [10, 12, 14, 20, 22],
		email: "yaminipanchala",
		consultationFees: 600,
		patientsCount: 100
	},
	{
		name: "devi prasad",
		qualification: "MBBS,MD(Gastro),DM",
		experience: 30,
		hospitalName: "Apollo Greams Road",
		description: "specialist in treating ibs and ibd Degree in Medicine (essential) . 5 years of residency training (essential).current state medical license and Federal DEA license (essential).Completed U.S. Medical Licensing Examination (essential).",
		slots: [10, 12, 14, 18, 20, 22],
		email: "deviprasad",
		consultationFees: 1200,
		patientsCount: 1000
	},
	{
		name: "yamini",
		qualification: "MBBS",
		experience: 22,
		hospitalName: "Apollo Greams Road",
		description: "specialist in surgery & Collect, record, and maintain sensitive patient information such as examination results, medical history, and reports.Perform minor surgeries.Explain procedures or prescribed treatments to patients,Liaise with medical professionals in the community and hospitals.",
		slots: [10, 12, 14, 20, 22],
		email: "yaminipanchala",
		consultationFees: 600,
		patientsCount: 100
	},
	{
		name: "akhil",
		qualification: "MBBS,MD(Gastro),DM",
		experience: 30,
		hospitalName: "Apollo Greams Road",
		description: "specialist in surgery & Collect, record, and maintain sensitive patient information such as examination results, medical history, and reports.Perform minor surgeries.Explain procedures or prescribed treatments to patients,Liaise with medical professionals in the community and hospitals.",
		slots: [10, 12, 14, 18, 20, 22],
		email: "akhil",
		consultationFees: 1200,
		patientsCount: 1000
	},
	{
		name: "selvaraj",
		qualification: "MBBS",
		experience: 22,
		hospitalName: "Apollo Greams Road",
		description: "specialist in surgery & Collect, record, and maintain sensitive patient information such as examination results, medical history, and reports.Perform minor surgeries.Explain procedures or prescribed treatments to patients,Liaise with medical professionals in the community and hospitals.",
		slots: [10, 12, 14, 20, 22],
		email: "selvaraj",
		consultationFees: 600,
		patientsCount: 100
	},
	{
		name: "indhumathi",
		qualification: "MBBS,MD(Gastro),DM",
		experience: 30,
		hospitalName: "Apollo Greams Road",
		description: "specialist in surgery",
		slots: [10, 12, 14, 18, 20, 22],
		email: "indhumathi",
		consultationFees: 1200,
		patientsCount: 1000
	},
	{
		name: "pethu",
		qualification: "MBBS",
		experience: 22,
		hospitalName: "Apollo Greams Road",
		description: "specialist in treating ibs and ibd",
		slots: [10, 12, 14, 20, 22],
		email: "pethuraj",
		consultationFees: 600,
		patientsCount: 100
	}
]

export const addressList = [
	"alpha@gmail.com", "beta@gmail.com", "gamma@gmail.com", "theta@gmail.com","gamma@yahoo.com"
]

export const sampleMailData = {
	userId: "kjhsfkjhsdjf",
	inbox: [{
		id: "one",
		emailId: "ashwin",
		date: "08-02-1988",
		content: "one",
		subject: "kjh",
	}, {
		id: "two",
		emailId: "rishi",
		date: "08-02-1988",
		content: "two",
		subject: "kjh",
	},
	{
		id: "three",
		emailId: "rishi",
		date: "08-02-1988",
		content: "three",
		subject: "kjh",
	}],
	sent: [
		{
			id: "four",
			emailId: "alpha",
			date: "08-02-1988",
			content: "kjkjfjhlsidfkskfksdhflsdjkfkjsf",
			subject: "kjh",

		}, {
			id: "five",
			emailId: "beta",
			date: "08-02-1988",
			content: "kjkjfjhlsidfkskfksdhflsdjkfkjsf",
			subject: "kjh",
		},
		{
			id: "six",
			emailId: "gamma",
			date: "08-02-1988",
			content: "kjkjfjhlsidfkskfksdhflsdjkfkjsf",
			subject: "kjh",
		}
	],
	starred: [],
	deleted: []
}

export const defaultMailData = {
	inbox: [

	],
	starred: [

	],
	sent: [],
	social: [],
	deleted: []
}